module.exports = __webpack_public_path__ + "img/TeacherSamanthaF.796bbf89.png";